import React from 'react';
import { Link } from 'react-router-dom';

const values = [
  { i: '🤝', t: 'Local & personal', d: 'We live and work in the same neighbourhoods we serve. You get real people who care, not a faceless chain.' },
  { i: '🧼', t: 'Proper care', d: 'Every item is checked, treated and finished by hand. We look after your clothes like they were our own.' },
  { i: '🌿', t: 'Kinder cleaning', d: 'Gentle, eco-friendly products that are better for your clothes and for the planet.' },
  { i: '⏱️', t: 'Fast & reliable', d: 'Free collection and delivery from your door, with most orders back within about 48 hours.' }
];

const About = () => (
  <div>
    <section className="hero" style={{ padding: '3.5rem 1.5rem' }}>
      <div className="hero-inner" style={{ gridTemplateColumns: '1fr' }}>
        <div>
          <span className="hero-eyebrow">🤝 Hello from the team</span>
          <h1>Laundry, done the neighbourly way.</h1>
          <p className="lead" style={{ maxWidth: '58ch' }}>
            Veni Vidi Laundry started with a simple belief: nobody should lose their weekend to
            washing, drying and ironing. So we do it for you — collecting from your door, caring for
            every item, and bringing it all back fresh.
          </p>
          <div className="hero-buttons">
            <Link to="/register" className="btn btn-accent btn-lg">Get started</Link>
            <Link to="/pricing" className="btn btn-outline btn-lg">See pricing</Link>
          </div>
        </div>
      </div>
    </section>

    <div className="container">
      <h2 className="section-title">What we stand for</h2>
      <p className="section-sub">The little things that make a big difference.</p>
      <div className="cards-grid">
        {values.map((v) => (
          <div className="card" key={v.t}>
            <div className="feature-icon">{v.i}</div>
            <h3>{v.t}</h3>
            <p style={{ marginBottom: 0 }}>{v.d}</p>
          </div>
        ))}
      </div>
    </div>

    <div className="section-tint">
      <div className="container" style={{ textAlign: 'center', maxWidth: '760px' }}>
        <h2 className="section-title">A note from us</h2>
        <p style={{ fontSize: '1.1rem', color: 'var(--ink-soft)' }}>
          We're a small, family-run team and we treat every customer like a neighbour — because you are one.
          Whether it's your weekly wash or a favourite suit that needs freshening up, we'll take good care of it.
          Got a question or a special request? Just <Link to="/contact">get in touch</Link> — we'd love to help.
        </p>
      </div>
    </div>

    <div className="container" style={{ textAlign: 'center' }}>
      <div className="card" style={{ background: 'var(--primary)', border: 'none', color: '#fff', padding: '2.6rem' }}>
        <h2 style={{ color: '#fff', marginBottom: '0.6rem' }}>Ready to win back your weekend?</h2>
        <Link to="/register" className="btn btn-accent btn-lg">Get started today</Link>
      </div>
    </div>
  </div>
);

export default About;
